import { Stack, styled } from "@mui/material";

export const FundsTransferWrapper = styled(Stack)(({ theme }) => {
    return {
        gap: "var(--flex-gap)",
        padding: "var(--basic-padding)",
        backgroundColor: "var(--light-color)",
        borderRadius: "16px",
        overflow: "hidden",
        "& form": {
            display: "flex",
            flexDirection: "column",
            gap: "var(--flex-gap)",
            flex: 0.6,
        },
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        },
    }
});